





























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import BusinessHours from '@/components/BusinessHours/BusinessHours.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';


@Component({
	name: 'BusinessHoursSettings',
  	components: { BusinessHours, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getBusinessHours();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingBusinessHours;
  	}
}
